import Cookies from 'js-cookie';
import { global } from '../config';
import OSS from 'ali-oss';


/**
 * 百度统计初始化
 */
export function baiduStatistics() {
    window._hmt = window._hmt || [];
    (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?18fd37d414145c525285e6cf0f11dada";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();
}

/**
 * 发送事件分析
 * @param pageName  页面名称
 * @param action    动作
 * @param flag      标签/id
 */
export function baiduStatisticsBehaviour(pageName, action, flag) {
    if (typeof window._hmt == 'undefined') return;
    window._hmt.push(['_trackEvent', pageName, action, flag, 1]);
}

export function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    // let r = window.location.search.substr(1).replace('?', '&').match(reg);
    if (r !== null) return decodeURIComponent(r[2]);
    return 0;
}


export function setCookie(key, value) {
    let cookiePrefix = global.cookiePrefix;
    Cookies.remove(cookiePrefix + key);
    Cookies.set(cookiePrefix + key, value);
}
export function getCookie(key) {
    let cookiePrefix = global.cookiePrefix;
    return Cookies.get(cookiePrefix + key);
}
export function delCookie(key) {
    let cookiePrefix = global.cookiePrefix;
    return Cookies.remove(cookiePrefix + key);
}

export function imageUrl(str) {
    //对于存储在阿里云并且传入数据库完整地址的数据处理
    /*if(str.match(/huhuapp-images.huhustory.com/i) == 'huhuapp-images.huhustory.com'){
    }*/
    if (!str) {
        return ''
    }

    if (str.indexOf("huhuapp-images.huhustory.com") !== -1) {
        str = str.replace('http://', '').replace('https://', '').replace('huhuapp-images.huhustory.com/open/Public/Uploads', '');
        //传入加密地址或多余的参数的数据处理
        if (str.indexOf("?") !== -1) {
            str = str.match(/(\S*)\?/)[1];
        }
    }

    //http开头。不是阿里云存储的图片，直接返回（原则上不存在这样的图片，可能有用户图像等）
    if (str.substr(0, 4) === "http") return str;

    let store = new OSS({
        //region: 'oss-cn-hangzhou', //oss-cn-hangzhou.aliyuncs.com
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
        accessKeyId: 'Hadn7yO0PJGB8FgV',
        accessKeySecret: 'nCDMNAJRM1jUXc6rsEODXw5US8fWVH',
        cname: true,
        bucket: 'huhuapp-image',
        endpoint: 'huhuapp-images.huhustory.com'
    });
    return store.signatureUrl('open/Public/Uploads' + str, {
        expires: 3600,
        method: 'GET'
    });
}